import { RendererProps } from "../renderers";
import { defineMessages, FormattedMessage } from "react-intl";
import React from "react";
import { asUTC } from "../../../lib/dateUtils";

const messages = defineMessages({
  noLimit: {
    id: "app.noLimit",
    defaultMessage: "no limit",
  },
});

function isDateValid(value: unknown): value is Date {
  return value instanceof Date && isFinite((value as unknown) as number);
}

export function DateRangeStringRenderer({
  value,
}: RendererProps<
  | {
      from: Date;
      to: Date;
    }
  | undefined
>) {
  let startDate: any = <FormattedMessage {...messages.noLimit} />;
  let endDate: any = <FormattedMessage {...messages.noLimit} />;

  if (value?.from && isDateValid(value?.from)) {
    startDate = asUTC(value.from);
  }
  if (value?.to && isDateValid(value?.to)) {
    endDate = asUTC(value.to);
  }

  return (
    <div>
      {startDate} - {endDate}
    </div>
  );
}
